export default class FilterContents {
  constructor (targets, limit) {
    this.targets = targets
    this.limit = limit
    this.reset()
  }

  reset () {
    this.numShown = 0
    this.numFiltered = 0
  }

  renderByFilter (filter, ignoreLimit = false) {
    this.reset()
    this.targets.forEach((el) => {
      const types = el.getAttribute('data-filter-content')
      let limit = 0
      if (filter === 'all' || types.split(',').indexOf(filter) !== -1) {
        limit = ignoreLimit ? -1 : this.limit
        this.numFiltered += 1
      }

      this.showContentsWithLimit(el, limit)
    })
  }

  showContentsWithLimit (el, limit) {
    let display = 'none'
    const item = el
    if (limit < 0 || this.numShown < limit) {
      this.numShown += 1
      display = 'block'
    }

    item.style.display = display
  }
}
